import { render, staticRenderFns } from "./StudentAiTutorBoardView.vue?vue&type=template&id=44d7e820&scoped=true&"
import script from "./StudentAiTutorBoardView.vue?vue&type=script&lang=js&"
export * from "./StudentAiTutorBoardView.vue?vue&type=script&lang=js&"
import style0 from "./StudentAiTutorBoardView.vue?vue&type=style&index=0&id=44d7e820&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44d7e820",
  null
  
)

export default component.exports